import React, { useState} from 'react'
import DropdownList from './../assessments/DropdownList.js'
import axios from 'axios';
import "react-step-progress-bar/styles.css";
import { ProgressBar } from "react-step-progress-bar";

const AnswerPart = (props) => {
    const [behavior, setBehavior] = useState(props.BehaviorDetail);
    const [progress, setProgress] = useState(0);
    const [ajaxRequest, setAjaxRequest] = useState(false);
    const selectBehavior=(b)=>{
      setBehavior(b);
      setAjaxRequest(true);
      setProgress(50);
      axios.post('/userassessments/update', {
        Id: props.Id,
        Label: b.Label
      })
      .then(function (response) {
        setProgress(100);
        setAjaxRequest(false);
      })
      .catch(function (error) {
        setProgress(100);
        setAjaxRequest(false);
      });
    }

  return (
    <div key={props.UserAnswerId}>
        <hr />
        <p>{props.AnswerPart}</p> 
        { ajaxRequest == true ? <ProgressBar
        percent={progress}
        filledBackground="linear-gradient(to right, #fefb72, #f0bb31)"
      /> : ""}
        <DropdownList behavior={behavior} behaviors={props.behaviors} setBehavior={selectBehavior} />
    </div>
  )
}

export default AnswerPart
